import request from 'tools/request'

// The client's sales rep users; the ones the application is shared with carry sharedAt and sharedBy.
export const getApplicationShares = (applicationId) =>
  request(`applications/${applicationId}/shares`, 'GET')

export const shareApplications = (applicationIds, userIds) =>
  request('applications/shares', 'POST', { applicationIds, userIds })

export const unshareApplication = (applicationId, userId) =>
  request(`applications/${applicationId}/shares/${userId}`, 'DELETE')
